import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPool } from './pools.transformers';
import type { PoolsCollection } from './pools.types';

export function poolsReducer(
  state: CollectionStateSlice<PoolsCollection> = {},
  action: CollectionActions<PoolsCollection>,
): CollectionStateSlice<PoolsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'pools') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<PoolsCollection>(
          state,
          transformIntoDocuments(result.pool_models, transformPool),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_DELETE_SUCCESS':
      if (action.payload.type === 'pools') {
        const { originalDocument, ref } = action.payload;
        return removeDocumentById<PoolsCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }

      return state;

    default:
      return state;
  }
}
